module.exports = __webpack_public_path__ + "img/ANTENNA RADIO LIME.0041231.svg";